/**
 * Determines if design lab tabs should be reordered based on the ab_design_lab_reorder_tabs experiment
 * Variant 1 (candidate) shows the new order: Upload -> Design -> Products -> Sizes
 * Variant 0 (control) shows the original order: Upload -> Products -> Sizes -> Front -> Back
 * @param experimentValue - The experiment variant value (0-1)
 * @returns true if tabs should be reordered, false if original order should be used
 */
export function shouldReorderDesignLabTabs(experimentValue: number | undefined): boolean {
  return experimentValue === 1;
}

/**
 * Determines if pin-based redraw should be enabled based on the ab_pin_based_redraw_notes or ab_pin_based_redraw_notes_v2 experiment
 * The backend fully gates this feature - it returns true only if:
 * - User has role override, OR
 * - Experiment flip is enabled AND user is variant 1
 *
 * This function just uses the backend-computed value for consistency.
 * @param _experimentValue - The experiment variant value (unused, backend handles gating)
 * @param flipEnabled - The boolean flag from backend (backend fully gates the feature)
 * @returns true if pin-based redraw should be enabled, false if old UI should be shown
 */
export function shouldEnablePinBasedRedraw(
  _experimentValue: number | undefined,
  _experimentValueV2: number | undefined,
  flipEnabled: boolean
): boolean {
  // Backend fully gates the feature - just use the backend value
  // Backend returns true only if: role override OR (experiment flip enabled AND variant 1)
  return flipEnabled;
}

/**
 * Determines if exit intent modal should be shown based on ab_exit_modal_design_lab experiment
 * Variant 1 (candidate) shows the modal on exit intent and inactivity
 * Variant 0 (control) disables the modal entirely
 * @param experimentValue - The experiment variant value (0-1)
 * @returns true if modal should be enabled, false if disabled
 */
export function shouldShowExitIntentModal(experimentValue: number | undefined): boolean {
  return experimentValue === 1;
}
